(function () {

  'use strict';

  function pxMaxDecimals() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attributes, ngModelController) {

        scope.regularExpression = buildRegularExpression(attributes.pxMaxDecimals);

        scope.$watch(function () {
          return attributes.pxMaxDecimals;
        }, function (value) {
          scope.regularExpression = buildRegularExpression(value);
          ngModelController.$validate();
        });

        ngModelController.$validators.pxMaxDecimals = function (modelValue, viewValue) {
          const value = modelValue || viewValue;
          return hasAllowedNumberOfDecimals(value);
        };

        function buildRegularExpression(decimals) {
          if (decimals === '' || decimals < 0) {
            return undefined;
          }
          return new RegExp(+decimals === 0 ? '^-?\\d+$' : `^(-?\\d+|-?\\d+[\\.,]\\d{1,${+decimals}})$`);
        }

        function hasAllowedNumberOfDecimals(value) {
          return !value || !scope.regularExpression || scope.regularExpression.test(value);
        }

      }
    };
  }

  pxMaxDecimals.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxMaxDecimals', pxMaxDecimals);

})();
